"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountingChildSyncType = void 0;
var AccountingChildSyncType;
(function (AccountingChildSyncType) {
    AccountingChildSyncType[AccountingChildSyncType["DEFAULT"] = 0] = "DEFAULT";
    AccountingChildSyncType[AccountingChildSyncType["PARENT_INHERIT"] = 1] = "PARENT_INHERIT";
})(AccountingChildSyncType = exports.AccountingChildSyncType || (exports.AccountingChildSyncType = {}));
//# sourceMappingURL=accounting.js.map